import { forwardRef, useContext } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import {
  type TDialogTitleElement,
  type TDialogTitleProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { TextTitle } from "@/ui/components/typography/TextTitle";
import {
  DialogHeaderSizeContext,
} from "@/ui/components/overlay/Dialog/DialogHeader";

export const DialogTitle = forwardRef<TDialogTitleElement, TDialogTitleProps>(
  (
    {
      className,
      children,
      ...props
    },
    ref,
  ) => {
    const size = useContext(DialogHeaderSizeContext);

    return (
      <DialogPrimitive.Title
        data-component="DialogTitle"
        ref={ref}
        className={cn(
          "font-sys-heading text-sys-lg leading-sys-1-2 text-foreground",
          className,
        )}
        {...props}
      >
        { size === "lg" ? (
          <TextTitle
            tag="div"
            size={3}
            isResponsive={false}
            className="block"
          >
            { children }
          </TextTitle>
        ) : (
          <TextSubtitle
            tag="span"
            size={1}
            isResponsive={false}
            className="block"
          >
            { children }
          </TextSubtitle>
        ) }
      </DialogPrimitive.Title>
    );
  },
);

DialogTitle.displayName = DialogPrimitive.Title.displayName;
